import Marketing from './marketing';

export { Marketing }
